import { configure } from 'vee-validate'

export const veeValidatePlugin = {
  install() {
    configure({
      validateOnBlur: true,
      validateOnChange: true,
      validateOnInput: false,
      validateOnModelUpdate: true,
    })
  },
}
